import React from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

const steps = [
  ['01', 'Discover', 'Authority source'],
  ['02', 'Validate', 'Check and retain'],
  ['03', 'Review', 'Resolve exceptions'],
  ['04', 'Act', 'Manage obligations'],
];

/** A compact visual explanation of the ingestion journey. */
export default function IngestionFlowDiagram() {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 0 }} alignItems="stretch">
      {steps.map(([number, title, detail], index) => (
        <React.Fragment key={title}>
          <Box sx={{ flex: 1, p: 1.5, border: '1px solid', borderColor: 'divider', bgcolor: index === 3 ? '#F0FDF4' : '#F8FAFF', borderRadius: index === 0 ? '8px 0 0 8px' : index === steps.length - 1 ? '0 8px 8px 0' : 0 }}>
            <Typography variant="overline" color="primary" fontWeight={700}>{number}</Typography>
            <Typography variant="subtitle2" fontWeight={700}>{title}</Typography>
            <Typography variant="caption" color="text.secondary">{detail}</Typography>
          </Box>
          {index < steps.length - 1 && <ArrowForward sx={{ alignSelf: 'center', mx: 0.5, color: 'text.secondary', display: { xs: 'none', sm: 'block' } }} />}
        </React.Fragment>
      ))}
    </Stack>
  );
}
